<template>
  <div>
    <b-button
      variant="primary"
      @click="addGoodsItem"
      size="sm"
      class="mb-4"
      squared
    >
      Добавить товар
    </b-button>
    <b-table
      id="data_table"
      hover
      show-empty
      responsive
      ref="goods"
      :fields="fields"
      :items="GOODS.GOODS_ITEM"
      :current-page="currentPage"
      :per-page="perPage"
      class="mt-3"
      empty-text="Нет данных в таблице"
    >
      <template v-slot:cell(Key)="data">
        <p class="mb-0">{{ data.index + 1 }}{{ calcGoodsNumeric(data.index + 1, data.item) }}</p>
      </template>
      <template v-slot:cell(GoodsCode)="data">
        <p class="mb-0">{{ data.item.GoodsCode }}<br v-if="data.item.GoodsCode">{{ data.item.GoodsDescription }}</p>
      </template>
      <template v-slot:cell(GrossWeightQuantity)="data">
        <p class="mb-0">
          <span v-if="data.item.GrossWeightQuantity">брутто&nbsp;{{ data.item.GrossWeightQuantity }}<br></span>
          <span v-if="data.item.NetWeightQuantity">нетто&nbsp;{{ data.item.NetWeightQuantity }}<br></span>
        </p>
      </template>
      <template v-slot:cell(GoodsQuantity)="data">
        <p class="mb-0">{{ data.item.GoodsQuantity }} {{ data.item.MeasureUnitQualifierName }}</p>
      </template>      
      <template v-slot:cell(CurrencyQuantity)="data">
        <p class="mb-0">
          <span v-if="data.item.CurrencyQuantity">{{ data.item.CurrencyQuantity }} {{ data.item.CurrencyCodeABR }}<br></span>
          <span v-if="data.item.CurrencyQuantitySub">{{ data.item.CurrencyQuantitySub }} {{ data.item.CurrencyCodeSubABR }}<br></span>
        </p>
      </template>
      <template v-slot:cell(actions)="data">
        <div class="actions-wrapper justify-content-start">
          <div class="btn-wrapper">
            <b-button id="open-documents-btn" @click="deleteGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Удалить">
              <font-awesome-icon icon="fa-solid fa-xmark" />
            </b-button>
            <b-button id="open-documents-btn" @click="editGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Редактировать">
              <font-awesome-icon icon="fa-solid fa-pencil" />
            </b-button>
            <b-button id="open-documents-btn" @click="cloneGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Дублировать">
              <font-awesome-icon icon="fa-solid fa-clone" />
            </b-button>
          </div>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col xl="6" lg="12" md="12" sm="12" cols="12">
        <div style="font-size: 14px;">
          <h4 class="form-title-summary">Итого: </h4>
          <span>Количество: {{ calcGoodsAmount() }}. </span>
          <span>Вес брутто (кг): {{ calcGrossWeightQuantity() }}. </span>
          <span>Стоимость в рублях: {{ calcWaybillAmount() }} {{ calcCurrencyCodeABR() }}. </span>
          <span>Таможенная стоимость: {{ calcWaybillCustomsCost() }} {{ calcCustomsCurrencyCodeABR() }}</span>
        </div>
      </b-col>
    </b-row>
    <add-goods-page ref="addGoods" @addGoods="saveGoods($event)" @editGoods="saveEditedGoods($event)" @saveEmptyPackageInIdb="$emit('updateHouseShipment')" :addGood="addGood" :notForEdit="notForEdit"></add-goods-page>
  </div>
</template>

<script>
  import AddGoodsPage from './AddHouseShipmentGoodsPage.vue'
  import idbapi from '../../../idbapi/idb.js'
  export default {
    name: "HouseShipmentGoodsPage",
    props: ['getValidationState', 'houseShipment', 'notForEdit'],
    components: {
      AddGoodsPage
    },
    data () {
      return {
        fields: [
          { key: 'Key', label: '№' },
          { key: 'GoodsCode', label: 'ТНВЭД, Описание товара' },
          { key: 'GrossWeightQuantity', label: 'Вес (кг), Объём (м3)' },
          { key: 'GoodsQuantity', label: 'Количество' },
          { key: 'CurrencyQuantity', label: 'Стоимость' },
          { key: 'Actions', label: 'Действия', stickyColumn: true }
        ],
        currentPage: 1,
        totalRows: 1,
        perPage: 0,
        pageOptions: [10, 20, 50],
        GOODS: {
          GOODS_ITEM: []
        },
        addGood: true,
        editedGoodIndex: null,
        TotalGoodsNumber: null,
        TotalWaybillGrossWeightQuantity: null, // Общий вес брутто (кг) по индивидуальной накладной
        TotalWaybillAmount: null, // Общая стоимость товаров по индивидуальной накладной в валюте
        TotalWaybillCurrencyCode: null, // Цифровой код валюты
        TotalWaybillCurrencyCodeABR: null, // Буквенный код валюты
        TotalWaybillCustomsCost: null, // Общая таможенная стоимость товаров по индивидуальной накладной
        TotalWaybillCustomsCurrencyCode: null, // Цифровой код валюты
        TotalWaybillCustomsCurrencyCodeABR: null, // Буквенный код валюты
      }
    },
    watch: {
      houseShipment (val) {
        if (val) {
          Object.assign(this.GOODS, val.data.GOODS)
          this.TotalGoodsNumber = val.data.TotalGoodsNumber
          this.TotalWaybillGrossWeightQuantity = val.data.TotalWaybillGrossWeightQuantity
          this.TotalWaybillAmount = val.data.TotalWaybillAmount
          this.TotalWaybillCurrencyCodeABR = val.data.TotalWaybillCurrencyCodeABR
          this.TotalWaybillCurrencyCode = val.data.TotalWaybillCurrencyCode
          this.TotalWaybillCustomsCost = val.data.TotalWaybillCustomsCost
          this.TotalWaybillCustomsCurrencyCodeABR = val.data.TotalWaybillCustomsCurrencyCodeABR
          this.TotalWaybillCustomsCurrencyCode = val.data.TotalWaybillCustomsCurrencyCode
        }
      },
    },
    mounted () {},
    computed: {},
    methods: {
      async cloneGoodsItem (data) {
        const good = this.GOODS.GOODS_ITEM[data.index]
        this.GOODS.GOODS_ITEM.push(good)
        await this.updateIdbData()
      },
      updateIdbData () {
        this.$emit('updateHouseShipment')
      },
      calcGoodsNumeric (value, item) {
        item.GoodsNumeric = value
      },
      calcGoodsAmount () {
        this.TotalGoodsNumber = this.GOODS.GOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.GoodsQuantity === null) || (current.GoodsQuantity === '')) ? 0 : parseFloat(current.GoodsQuantity))
        }, 0)
        return this.TotalGoodsNumber
      },
      calcGrossWeightQuantity () {
        this.TotalWaybillGrossWeightQuantity = this.GOODS.GOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.GrossWeightQuantity === null) || (current.GrossWeightQuantity === '')) ? 0 : parseFloat(current.GrossWeightQuantity))
        }, 0)
        return this.TotalWaybillGrossWeightQuantity
      },
      calcNetWeightQuantity () {
        return this.GOODS.GOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.NetWeightQuantity === null) || (current.NetWeightQuantity === '')) ? 0 : parseFloat(current.NetWeightQuantity))
        }, 0)
      },
      calcWaybillAmount () {
        this.TotalWaybillAmount = this.GOODS.GOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.CurrencyQuantitySub === null) || (current.CurrencyQuantitySub === '')) ? 0 : parseFloat(current.CurrencyQuantitySub))
        }, 0)
        return this.TotalWaybillAmount
      },
      calcWaybillCustomsCost () {
        this.TotalWaybillCustomsCost = this.GOODS.GOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.CustomsCost === null) || (current.CustomsCost === '')) ? 0 : parseFloat(current.CustomsCost))
        }, 0)
        return this.TotalWaybillCustomsCost
      },
      calcCurrencyCodeABR () {
        this.TotalWaybillCurrencyCode = this.GOODS.GOODS_ITEM[0]?.CurrencyCodeSub
        this.TotalWaybillCurrencyCodeABR = this.GOODS.GOODS_ITEM[0]?.CurrencyCodeSubABR
        return this.TotalWaybillCurrencyCodeABR
      },
      calcCustomsCurrencyCodeABR () {
        this.TotalWaybillCustomsCurrencyCode = this.GOODS.GOODS_ITEM[0]?.CustomsCurrencyCode
        this.TotalWaybillCustomsCurrencyCodeABR = this.GOODS.GOODS_ITEM[0]?.CustomsCurrencyCodeABR
        return this.TotalWaybillCustomsCurrencyCodeABR
      },
      async saveGoods (data) {
        this.GOODS.GOODS_ITEM.push(data.GOODS_ITEM[0])
        this.$refs.addGoods.resetSidebarData()
        await this.$emit('updateHouseShipment')
      },
      async saveEditedGoods (data) {
        this.GOODS.GOODS_ITEM.splice(this.editedGoodIndex, 1, data.GOODS_ITEM[0])
        this.editedGoodIndex = null
        this.$refs.addGoods.resetSidebarData()
        await this.$emit('updateHouseShipment')
      },
      deleteGoodsItem (row) {
        this.GOODS.GOODS_ITEM.splice(row.index, 1)
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              idbapi.deleteGoodFromHouseshipmentData(row.index)
            } else {
              this.$emit('updateHouseShipment')
              setTimeout(() => {
                idbapi.deleteGoodFromHouseshipmentData(row.index)
              }, 200)
            }
          }
        )
      },
      editGoodsItem (row) {
        this.addGood = false
        this.editedGoodIndex = row.index
        this.$refs.addGoods.mergeEditedGoodsItem(JSON.parse(JSON.stringify(this.GOODS.GOODS_ITEM[row.index])))
      },
      addGoodsItem () {
        this.addGood = true
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
      },
      resetFormData () {
        this.GOODS.GOODS_ITEM = []
        this.TotalGoodsNumber = null
        this.TotalWaybillGrossWeightQuantity = null
        this.TotalWaybillAmount = null
        this.TotalWaybillCurrencyCodeABR = null
        this.TotalWaybillCurrencyCode = null
        this.TotalWaybillCustomsCost = null
        this.TotalWaybillCustomsCurrencyCodeABR = null
        this.TotalWaybillCustomsCurrencyCode = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .actions-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    .btn-wrapper {
      height: 32px;
      display: flex;
    }
    .actions-with-outline {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      position: relative;
      border: 2px solid #CFD8DC;
      &:nth-child(1) {
        margin-right: 0.75rem;
      }
      &:nth-child(2) {
        margin-right: 0.75rem;
      }
      &:hover {
        color: #fff !important;
        cursor: pointer;
      }
      svg {
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 8px;
        position: absolute;
        top: calc((100% - 16px) / 2);
        left: calc((100% - 16px) / 2);
      }
    }
  }
  #GoodsDescription {
    border-radius: 0 !important;
  }
  h4.form-title-summary {
    font-weight: 500;
    color: #25282E;
    font-size: 14px;
    line-height: 20px;
    margin-top: 0;
  }
</style>
